import { bindActionCreators, } from 'redux';
import { connect, } from 'react-redux';
import * as Signup from '../actions/Signup';
import * as Signin from '../actions/Signin';
import * as Estimate from '../actions/EstimateAction';
import * as Shipment from '../actions/ShipmentAction';
import * as Cms from '../actions/CmsActions';
import * as SettingsAction from '../actions/SettingsAction';


import Main from './Main';

function mapStateToProps(state){
  return{
    login: state.signin,
    register: state.signup,
    auth: state.auth,
    estimate: state.estimate,
    shipmentInfo:state.shipment,
    cms: state.cms,
    settings: state.settings,

  }
}

function mapDispachToProps(dispatch){
  return bindActionCreators(Object.assign({},Signin, Signup,Estimate,Shipment,Cms,SettingsAction), dispatch);
}

const App = connect(mapStateToProps, mapDispachToProps)(Main);

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/